/* eslint-disable prettier/prettier */
import React from 'react';

const AlertMessage = props => {

    return (
        <div className="blue-light-treatment">
            {props.message}
        </div>
    );
};

export default AlertMessage;